export default __webpack_public_path__ + "static/media/menu-24px.501536c5.svg";